export function selectedMapFeatureId(feature) {
  if (!feature) return null;
  const raw = feature.properties?.id ?? feature.id;
  if (raw == null || raw === '') return null;
  return raw;
}

export function selectedMapFeatureFilter(id) {
  if (id == null || id === '') return ['==', ['get', 'id'], '__none__'];
  const asString = String(id);
  const asNumber = Number(id);
  if (Number.isFinite(asNumber) && String(asNumber) === asString) {
    return [
      'any',
      ['==', ['id'], asNumber],
      ['==', ['get', 'id'], asNumber],
      ['==', ['get', 'id'], asString],
    ];
  }
  return ['any', ['==', ['id'], asString], ['==', ['get', 'id'], asString]];
}

export const SELECTED_FEATURE_LAYERS = [
  {
    id: 'yona-selected-polygons-glow',
    type: 'line',
    source: 'features-polygons',
    paint: {
      'line-color': '#B4501C',
      'line-width': 8,
      'line-opacity': 0.28,
    },
  },
  {
    id: 'yona-selected-polygons',
    type: 'line',
    source: 'features-polygons',
    paint: {
      'line-color': '#B4501C',
      'line-width': 3,
      'line-opacity': 1,
    },
  },
  {
    id: 'yona-selected-lines-glow',
    type: 'line',
    source: 'features-lines',
    paint: {
      'line-color': '#B4501C',
      'line-width': 8,
      'line-opacity': 0.28,
    },
  },
  {
    id: 'yona-selected-lines',
    type: 'line',
    source: 'features-lines',
    paint: {
      'line-color': '#B4501C',
      'line-width': 3,
      'line-opacity': 1,
    },
  },
  {
    id: 'yona-selected-points-halo',
    type: 'circle',
    source: 'features-points',
    paint: {
      'circle-radius': 16,
      'circle-color': '#B4501C',
      'circle-opacity': 0.22,
    },
  },
  {
    id: 'yona-selected-points',
    type: 'circle',
    source: 'features-points',
    paint: {
      'circle-radius': 10,
      'circle-color': 'transparent',
      'circle-stroke-color': '#B4501C',
      'circle-stroke-width': 3,
    },
  },
];

export function applySelectedFeatureLayers(map, id) {
  if (!map || typeof map.getSource !== 'function') return;
  const filter = selectedMapFeatureFilter(id);
  SELECTED_FEATURE_LAYERS.forEach((layer) => {
    if (!map.getSource(layer.source)) return;
    if (!map.getLayer(layer.id)) {
      try {
        map.addLayer({ ...layer, filter });
      } catch (_) {}
      return;
    }
    try {
      map.setFilter(layer.id, filter);
    } catch (_) {}
  });
}
